<template>
    <div class="pt-3 pb-3">
        <div class="text-center"  v-if="popupBatchUpdate.isLoading">
			<img src="@/assets/loading-logo-animation.gif" style="width: 75px"/>
			
			<p class="font-weight-bold">{{$t('THE_SYSTEM_IS_LOADING')}}</p>
		</div>
        <div v-if="!popupBatchUpdate.isLoading">
            <div class="d-sticky h-header-table d-flex">
                <div class="mr-auto d-flex align-items-center"> 	
                    <div class="font-weight-bold text-primary text-uppercase px-3">
                        {{ $t("FROM_DATE") }} - {{ $t("TO_DATE") }}
                    </div>
                </div> 
                <div> 	
                    <div class="small-gutters d-flex"> 	
                        <div class="text-center font-weight-bold w-input-update" v-for="item in popupBatchUpdate.daysOfWeek" >{{ item.value }}</div> 	
                    </div> 
                </div>
            </div>

            <div class="d-flex mt-1" v-for="(item, i) in popupBatchUpdate.avail.listOfPeriod" :key="i">
                <div class="mr-auto d-date d-flex align-items-center px-3">
                    <date-picker :disabled-date="notBeforeToday" :confirm="true" :confirm-text="$t('CONFIRM')" :clearable="false"  
                        :popup-class="'popup-calendar-desktop-detailhotel'" v-model="item.dateSelect" :lang="languageDate" :format="'DD/MM/YYYY'" 
                        :shortcuts=[] range placeholder="Select date range">
                    </date-picker>
                    <v-icon
                        v-if="popupBatchUpdate.avail.listOfPeriod.length > 1"
                        color="red"
                        size="16"
                        class="ml-3"
                        @click="removePeriodAvail(item)"
                        >delete</v-icon
                    >
                </div>
                <div >
                    <div class="small-gutters config-price">
                        
                        <v-btn color="primary" @click="copyRoomAvail(item, i)" class="ml-1" :title="$t('COPY')" icon small><i class="icon-content_paste_go fs-16"></i></v-btn>
                        <div class="w-input-update">
                                <div
                                    v-if="
                                        listDisableDayRoomAvail.length > 0 &&
                                        listDisableDayRoomAvail[i].MON.disable
                                    "
                                >
                                <v-text-field class="w-input-update text-right rounded"  outlined dense disabled></v-text-field>
                                </div>
                                <div v-else class="vertical-divider border-0">
                                    <v-text-field class="w-input-update text-right rounded" @keydown="validateInput" onkeyup="this.value=this.value.replace(/[^\d]/,'')" outlined dense v-model="item.value.MON"></v-text-field>
                                </div>
                        </div>
                        <div class="w-input-update">
                                <div
                                    v-if="
                                        listDisableDayRoomAvail.length > 0 &&
                                        listDisableDayRoomAvail[i].TUE.disable
                                    "
                                >
                                <v-text-field class="w-input-update text-right rounded"  outlined dense disabled></v-text-field>
                                </div>
                                <div v-else class="vertical-divider border-0">
                                    <v-text-field class="w-input-update text-right rounded" @keydown="validateInput" onkeyup="this.value=this.value.replace(/[^\d]/,'')" outlined dense v-model="item.value.TUE"></v-text-field>
                                </div>
                        </div>
                        <div class="w-input-update">
                                <div
                                    v-if="
                                        listDisableDayRoomAvail.length > 0 &&
                                        listDisableDayRoomAvail[i].WED.disable
                                    "
                                >
                                <v-text-field class="w-input-update text-right rounded"  outlined dense disabled></v-text-field>
                                </div>
                                <div v-else class="vertical-divider border-0">
                                    <v-text-field class="w-input-update text-right rounded" @keydown="validateInput" onkeyup="this.value=this.value.replace(/[^\d]/,'')" outlined dense v-model="item.value.WED"></v-text-field>
                                </div>
                        </div>
                        <div class="w-input-update">
                                <div
                                    v-if="
                                        listDisableDayRoomAvail.length > 0 &&
                                        listDisableDayRoomAvail[i].THU.disable
                                    "
                                >
                                <v-text-field class="w-input-update text-right rounded"  outlined dense disabled></v-text-field>
                                </div>
                                <div v-else class="vertical-divider border-0">
                                    <v-text-field class="w-input-update text-right rounded" @keydown="validateInput" onkeyup="this.value=this.value.replace(/[^\d]/,'')" outlined dense v-model="item.value.THU"></v-text-field>
                                </div>
                        </div>
                        <div class="w-input-update">
                                <div
                                    v-if="
                                        listDisableDayRoomAvail.length > 0 &&
                                        listDisableDayRoomAvail[i].FRI.disable
                                    "
                                >
                                <v-text-field class="w-input-update text-right rounded"  outlined dense disabled></v-text-field>
                                </div>
                                <div v-else class="vertical-divider border-0">
                                    <v-text-field class="w-input-update text-right rounded" @keydown="validateInput" onkeyup="this.value=this.value.replace(/[^\d]/,'')" outlined dense v-model="item.value.FRI"></v-text-field>
                                </div>
                        </div>
                        <div class="w-input-update">
                                <div
                                    v-if="
                                        listDisableDayRoomAvail.length > 0 &&
                                        listDisableDayRoomAvail[i].SAT.disable
                                    "
                                >
                                <v-text-field class="w-input-update text-right rounded"  outlined dense disabled></v-text-field>
                                </div>
                                <div v-else class="vertical-divider border-0">
                                    <v-text-field class="w-input-update text-right rounded" @keydown="validateInput" onkeyup="this.value=this.value.replace(/[^\d]/,'')" outlined dense v-model="item.value.SAT"></v-text-field>
                                </div>
                        </div>
                        <div class="w-input-update">
                                <div
                                    v-if="
                                        listDisableDayRoomAvail.length > 0 &&
                                        listDisableDayRoomAvail[i].SUN.disable
                                    "
                                >
                                <v-text-field class="w-input-update text-right rounded"  outlined dense disabled></v-text-field>
                                </div>
                                <div v-else class="vertical-divider border-0">
                                    <v-text-field class="w-input-update text-right rounded" @keydown="validateInput" onkeyup="this.value=this.value.replace(/[^\d]/,'')" outlined dense v-model="item.value.SUN"></v-text-field>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pt-2 pl-3">
                <v-btn color="primary" outlined  x-small @click="addDatePriodAvail()">
                    <v-icon color="#173d8f" small>add</v-icon>
                    <label class="has-action fs-10">{{ $t("ADD_DATE_RANGE") }}</label>
                </v-btn>
            </div>
        </div>
        <hr>
        <div class="pl-3 pr-3 " v-if="!popupBatchUpdate.isLoading"> 
            <label class="label-title">{{ $t("SELECT_ROOM_APPLY") }}</label>
            <v-row>
                <v-col md="4" class="pb-1 pt-1">
                    <v-checkbox
                        color="indigo darken-3"
                        :label="$t('SELECT_ALL')"
                        @change="clickSelectAll()"
                        v-model="selectAll"
                        class="p-0 m-0"
                    />
                </v-col>
                <v-col
                    md="4"
                    class="pb-0 pt-1"
                    v-for="item in listRoom"
                    >
                    <v-checkbox
                        v-model="popupBatchUpdate.avail.roomSelect"
                        :label="item.text"
                        :value="item.value"
                        color="primary"
                        class="p-0 m-0"
                        @change="$event => changeRoomSelect($event)"
                    ></v-checkbox>
                </v-col>
            </v-row>

        </div>
        <div class="text-right pt-3" v-if="!popupBatchUpdate.isLoading">
             <v-btn class="pl-5 mr-5" color="primary" @click="confirmUpdateRoomAvail()">
                <template>{{ $t("UPDATE") }}</template>
              </v-btn>
        </div>
    </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from "moment";
import { _alert } from "@/_helpers/function.js";
import { service } from "@/_services/SaleRoom/room-plan.service.js";
import { restriction } from "@/_services/SaleRoom/restriction.js";
export default {
    components: {
        "date-picker": DatePicker,
    },
    data() {
        return {
            availOptions: {
                locale: "vi",
                length: 3,
                precision: 0,
            },
            listDisableDayRoomAvail: [],
            popupBatchUpdate: {
                isLoading: true,
                avail: {
                    roomSelect: [],
                    listOfPeriod: [],
                    invalidDate: false,
                },
                daysOfWeek: [
                    { code: "MON", value: this.$t("MONDAY") },
                    { code: "TUE", value: this.$t("TUESDAY") },
                    { code: "WED", value: this.$t("WEDNESDAY") },
                    { code: "THU", value: this.$t("THURSDAY") },
                    { code: "FRI", value: this.$t("FRIDAY") },
                    { code: "SAT", value: this.$t("SATURDAY") },
                    { code: "SUN", value: this.$t("SUNDAY") },
                ],
            },
            selectedRoom: -1, // Phòng đang được sửa
            listRoom: [], // Danh sách các phòng, do dữ liệu roomData cấu thành list
            relationData: [], // Thông tin gói bán và giá của tất cả phòng do API trả về
            currentDate: new Date(),
            listOTA: [],
            selectedOTA: null,
            systemLang: this.$i18n.locale,
            selectAll: false
        };
    },
    computed: {
    },
    created() {
        this.initialize();
    },
    watch: {
        popupBatchUpdate: {
            handler(val) {
               this.listDisableDayRoomAvail = [];
                // Nếu ngày bắt đầu lớn hơn ngày kết thúc, set ngày kết thúc về rỗng.
                val.avail.listOfPeriod.forEach((x, index) => {
                    // Cho ngày của tất cả khoảng ngày mặc định ko được điền, sau đó mới check cụ thể ngày nào được điền
                    this.listDisableDayRoomAvail.push({
                        MON: {
                            disable: true,
                        },
                        TUE: {
                            disable: true,
                        },
                        WED: {
                            disable: true,
                        },
                        THU: {
                            disable: true,
                        },
                        FRI: {
                            disable: true,
                        },
                        SAT: {
                            disable: true,
                        },
                        SUN: {
                            disable: true,
                        },
                    });
                    var start = moment(x.dateSelect[0], "YYYY-MM-DD");
                    var end = moment(x.dateSelect[1], "YYYY-MM-DD");

                    // Kiểm tra khoảng ngày hiện tại có lớn hơn 7, nếu lớn hơn thì enable tất cả, nếu ko thì xem khoảng ngày có ngày nào.
                    let day = moment.duration(end.diff(start)).asDays();
                    // Reset lại toàn bộ
                    if (day < 6) {
                        while (start <= end) {
                            let daysOfWeek = this.formatDateOfWeek(start);
                            // Mở các thứ ở trong khoảng
                            this.listDisableDayRoomAvail[index][daysOfWeek].disable = false;
                            start = moment(start).add(1, "day");
                        }
                    } else {
                        // Nếu khoảng ngày trải dài cả tuần thì mở hết.
                        this.listDisableDayRoomAvail[index].MON.disable = false;
                        this.listDisableDayRoomAvail[index].TUE.disable = false;
                        this.listDisableDayRoomAvail[index].WED.disable = false;
                        this.listDisableDayRoomAvail[index].THU.disable = false;
                        this.listDisableDayRoomAvail[index].FRI.disable = false;
                        this.listDisableDayRoomAvail[index].SAT.disable = false;
                        this.listDisableDayRoomAvail[index].SUN.disable = false;
                    }
                });
                if (val.avail.roomSelect.length !== this.listRoom.length) {
                    this.selectAll = false
                } else {
                     this.selectAll = true
                }
            },
            deep: true,
        },
    },
    methods: {
        validateInput($event) {
            let key = $event.key;
            if (key == "Backspace" || key == "Delete" || key == "ArrowLeft" || key == "ArrowRight" || key == "Tab") return;
            if (!/[0-9]/.test(key)) {
                $event.preventDefault();
                return;
            }
        },
        _moment: moment,
        async initialize(isSearch) {
            this.popupBatchUpdate.isLoading = true;
            // Thêm khoảng ngày mặc định cho cập nhật phòng trống
            this.popupBatchUpdate.avail.listOfPeriod = [];
            let fromDateListOfPeriod = moment(this.currentDate).format("YYYY-MM-DD");
            let toDateListOfPeriod = moment(this.currentDate)
                .add(1, "day")
                .format("YYYY-MM-DD");

            this.popupBatchUpdate.avail.listOfPeriod.push({
                id: this.popupBatchUpdate.avail.length + 1,
                dateSelect: [new Date(fromDateListOfPeriod), new Date(toDateListOfPeriod)],
                value: {
                    MON: null,
                    TUE: null,
                    WED: null,
                    THU: null,
                    FRI: null,
                    SAT: null,
                    SUN: null,
                },
            });
            this.getAllRoomDefault();
        },
        inDays(d1, d2) {
            var t2 = d2.getTime();
            var t1 = d1.getTime();
    
            return parseInt((t2-t1)/(24*3600*1000));
        },
        async getAllRoomDefault() {
			await restriction.getAllRoomTyeHasRoomRate().then((res) => {
				if (res.responseCode == 0) {
					this.loadListRoom(res.data);
				}
			});
		},
        loadListRoom(data) {
            this.listRoom = [];
            this.listRoom = this.listRoom.concat(
                data.filter(e => !e.parent).map((room) => {
                    return {
                        value: room.id,
                        text: room.roomTypeI18n.find((x) => x.lang === this.defaultI18n).name,
                    };
                })
            );
            const params = JSON.parse(localStorage.getItem("roomRateUpdate"));
            if (params.roomId) {
               if (params.roomId != -1) {
                    const arr = [];
                    if (this.listRoom.filter(r => r.value === params.roomId).length > 0) {
                        arr.push(params.roomId)
                    }
                    if (arr.length > 0) {
                        this.popupBatchUpdate.avail.roomSelect = [...arr];
                        this.changeRoomSelect(arr);
                    } else {
                        this.popupBatchUpdate.avail.roomSelect.push(this.listRoom[1].value);
                    }
               } else {
                    this.popupBatchUpdate.avail.roomSelect = this.listRoom.map(e => e.value);
               }
            } else {
                this.popupBatchUpdate.avail.roomSelect.push(this.listRoom[1].value);
                 this.changeRoomSelect(this.listRoom[1].value);
            }
            this.popupBatchUpdate.isLoading = false;
        },
        addDatePriodAvail() {
            let prevPeriod = this.popupBatchUpdate.avail.listOfPeriod[
                this.popupBatchUpdate.avail.listOfPeriod.length - 1
            ];
            const tomorrow = new Date();
            tomorrow.setDate(new Date().getDate() + 365*2);
            if (new Date(moment(prevPeriod.dateSelect[1]).format("YYYY-MM-DD")) >= tomorrow) {
                return;
            }
            let from = moment(prevPeriod.dateSelect[1]).add(1, "day").format("YYYY-MM-DD");
            let to = moment(prevPeriod.dateSelect[1]).add(2, "day").format("YYYY-MM-DD");
            this.popupBatchUpdate.avail.listOfPeriod.push({
                id: this.popupBatchUpdate.avail.listOfPeriod[this.popupBatchUpdate.avail.listOfPeriod.length - 1].id + 1,
                dateSelect: [new Date(from), new Date(to)],
                value: {
                    MON: null,
                    TUE: null,
                    WED: null,
                    THU: null,
                    FRI: null,
                    SAT: null,
                    SUN: null,
                },
            });
        },
        copyRoomAvail(item, i) {
            var updateTo = [];
            var first = false;
            var value = null;
            if (!this.listDisableDayRoomAvail[i].MON.disable) {
                first = true;
                value = this.popupBatchUpdate.avail.listOfPeriod[i].value["MON"];
                updateTo.push("MON");
            }
            if (!this.listDisableDayRoomAvail[i].TUE.disable) {
                if (!first) {
                    first = true;
                    value = this.popupBatchUpdate.avail.listOfPeriod[i].value["TUE"];
                }
                updateTo.push("TUE");
            }
            if (!this.listDisableDayRoomAvail[i].WED.disable) {
                if (!first) {
                    first = true;
                    value = this.popupBatchUpdate.avail.listOfPeriod[i].value["WED"];
                }
                updateTo.push("WED");
            }
            if (!this.listDisableDayRoomAvail[i].THU.disable) {
                if (!first) {
                    first = true;
                    value = this.popupBatchUpdate.avail.listOfPeriod[i].value["THU"];
                }
                updateTo.push("THU");
            }
            if (!this.listDisableDayRoomAvail[i].FRI.disable) {
                if (!first) {
                    first = true;
                    value = this.popupBatchUpdate.avail.listOfPeriod[i].value["FRI"];
                }
                updateTo.push("FRI");
            }
            if (!this.listDisableDayRoomAvail[i].SAT.disable) {
                if (!first) {
                    first = true;
                    value = this.popupBatchUpdate.avail.listOfPeriod[i].value["SAT"];
                }
                updateTo.push("SAT");
            }
            if (!this.listDisableDayRoomAvail[i].SUN.disable) {
                if (!first) {
                    first = true;
                    value = this.popupBatchUpdate.avail.listOfPeriod[i].value["SUN"];
                }
                updateTo.push("SUN");
            }
            updateTo.forEach((x) => {
                this.popupBatchUpdate.avail.listOfPeriod[i].value[x] = value;
            });
        },
        formatDateOfWeek(date) {
            let dayOfWeek;
            switch (date.day()) {
                case 0: {
                    dayOfWeek = "SUN";
                    break;
                }
                case 1: {
                    dayOfWeek = "MON";
                    break;
                }
                case 2: {
                    dayOfWeek = "TUE";
                    break;
                }
                case 3: {
                    dayOfWeek = "WED";
                    break;
                }
                case 4: {
                    dayOfWeek = "THU";
                    break;
                }
                case 5: {
                    dayOfWeek = "FRI";
                    break;
                }
                case 6: {
                    dayOfWeek = "SAT";
                    break;
                }
            }
            return dayOfWeek;
        },
        removePeriodAvail(item) {
            this.popupBatchUpdate.avail.listOfPeriod.splice(
                this.popupBatchUpdate.avail.listOfPeriod.indexOf(item),
                1
            );
        },
        confirmUpdateRoomAvail() {
            let noted;
            let isUpdate = true;
            this.popupBatchUpdate.avail.listOfPeriod.forEach((x) => {
                if (this.get_day_of_time(new Date(x.dateSelect[0]), new Date(x.dateSelect[1])) > 365) {
                    _alert(null, this.$t("UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR"));
                    isUpdate = false
                    return true
                }
                if (!noted) {
                    noted = moment(x.dateSelect[1], "YYYY/MM/DD");
                    return true;
                }
                if (x.from <= noted) {
                    isUpdate = false
                    _alert(null, this.$t("_BATCH_UPDATE.MESSAGE.OVERLAP_TIME"));
                    this.popupBatchUpdate.avail.invalidDate = true;
                } else {
                    noted = moment(x.dateSelect[1], "YYYY/MM/DD");
                }
            });

            var dateValue = [];
            let isMaxRoom = false;
            this.popupBatchUpdate.avail.listOfPeriod.forEach((item) => {
                let fromDate = moment(item.dateSelect[0], "YYYY/MM/DD");
                let toDate = moment(item.dateSelect[1], "YYYY/MM/DD");
                while (fromDate <= toDate) {
                    let daysOfWeek = this.formatDateOfWeek(fromDate);
                    if (item.value[daysOfWeek] && item.value[daysOfWeek] <= 9999) {
                        dateValue.push({
                            apply: fromDate.format("YYYY-MM-DD"),
                            value: item.value[daysOfWeek],
                        });
                    } else if (item.value[daysOfWeek] > 9999){
                        _alert(null, this.$t("DATA_INPUT_INVALID"));
                        isMaxRoom = true;
                    }
                    fromDate = moment(fromDate).add(1, "day");
                }
            });

            let body = [];
            if (
                this.popupBatchUpdate.avail.roomSelect.length > 0 &&
                dateValue.length > 0 &&
                !this.popupBatchUpdate.avail.invalidDate && !isMaxRoom && isUpdate
            ) {
                this.popupBatchUpdate.avail.roomSelect.forEach((x) => {
                    body.push({
                        id: x,
                        dates: dateValue,
                    });
                });
                this.popupBatchUpdate.isLoading = true;
                service
                .updateAvailable(body)
                .then((res) => {
                    _alert(res, this.$t(res.data), false);
                })
                .finally(
                    () =>
                    (this.popupBatchUpdate.isLoading = false)
                );
            } else {
                _alert(null, this.$t("DATA_INPUT_INVALID"));
            }
        },
        clickSelectAll() {
            this.popupBatchUpdate.avail.roomSelect = [];
            if (this.selectAll) {
                this.listRoom.forEach(e => {
                    this.popupBatchUpdate.avail.roomSelect.push(e.value);
                });
            } else {
                this.popupBatchUpdate.avail.roomSelect = [];
            }
            this.changeRoomSelect(this.popupBatchUpdate.avail.roomSelect);
        }
    }
};
</script>